// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Cq-z","slideIn":"Dq-z"};